const Logo = ({ color = 'fill-neutral-800', className = 'w-32', ...rest }) => {
  return (
    <svg
      {...rest}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 847.98 348.11"
    >
      <path
        className={color}
        d="M155.39,394.22q21.74-25.41,43.45-50.81c7.56-8.86,15.06-17.76,22.79-26.87-19.49-24.45-38.86-48.77-58.69-73.66,1.74-.17,2.92-.39,4.1-.39,20.65,0,41.29.06,61.93-.09,3.1,0,4.73,1.12,6.34,3.59,6.53,10,13.28,19.9,20.13,30.1,15-22.85,29.78-45.33,44.37-67.94,2.05-3.17,4.15-4.29,7.91-4.26,21.81.21,43.62.1,65.42.1H379L289.22,316.55l57.55,68.66c.82-1.76,1.51-3.15,2.1-4.57q27.67-66.74,55.23-133.52c1.5-3.64,3.33-4.8,7.27-4.75,21,.23,41.95.26,62.92,0,4.14-.06,5.71,1.48,7.14,5Q509,314.1,536.73,380.79c.5,1.2,1,2.4,1.91,4.52l57.66-68.76-58.73-73.72c1.84-.15,3.09-.34,4.34-.34,20.47,0,41,.08,61.42-.11,3.32,0,5.12,1.16,6.81,3.76,6.44,9.89,13,19.66,19.92,30,6.72-10,13.35-19.66,19.63-29.51,2-3.21,4.29-4.27,8.06-4.23,21.29.2,42.58.09,65.11.09l-59,74.07,67.85,81H716.36c-18.14,0-36.29-.07-54.44.06a6.9,6.9,0,0,1-6.5-3.42c-8.26-12.08-16.71-24-25.33-36.36-8.45,12.09-16.81,23.86-24.91,35.81-2,2.95-4.14,4-7.72,4q-56.43-.21-112.87,0c-3.62,0-5.31-1-6.27-4.52-1.22-4.45-3.06-8.73-4.63-13.09H411.86l-6.41,17.53h-5.12c-37.46,0-74.92-.06-112.37.09a8.15,8.15,0,0,1-7.68-4.06c-8-11.82-16.29-23.51-24.83-35.77L216.6,416.3H731.22v10.23h-6.4q-254.46,0-508.91-.1c-4.45,0-7.11,1.23-9.63,5.06q-38.67,58.8-77.8,117.29c-1,1.49-3.23,3.08-4.89,3.09-33.13.18-66.26.13-99.38.12a10.66,10.66,0,0,1-1.85-.46C57.55,510,92.47,468.85,128.09,426.84H-116.22V416.47h5.9q120.85,0,241.72.08c3.78,0,6.51-.78,8.92-4,4.21-5.53,8.9-10.7,12.78-15.29-3.55-.63-8.27-.13-10.64-2.26s-2.1-6.81-3.11-10.77H92.68a35.58,35.58,0,0,1,1,4.33,7.8,7.8,0,0,1-6.9,8.83c-4.07.43-8.25-2.64-8.44-6.72-.26-5.55-.06-11.12-.06-16.89,3.92,0,7.44.17,10.93-.08a9.09,9.09,0,0,0,4.49-1.67c7.66-5.52,15.21-11.19,22.84-16.75a6.56,6.56,0,0,1,2.34-.61l.37.33c.26,1.12.14,2.76.85,3.29,6.53,4.84,12.91,10,20,14,3.22,1.8,7.84,1.12,11.84,1.52,1,.1,1.94,0,3.58,0-.36,6.76-.71,13.23-1.05,19.7L154.2,395ZM443.32,291l-1.11-.09c-5.66,16.8-11.31,33.6-17,50.64h35.22ZM79.44,382.16h74.43v-6.87H79.44Zm68.17,2.21c-1.7,2.23-3.62,3.67-3.43,4.76.24,1.47,2.1,2.68,3.27,4,1.23-1.27,3.15-2.39,3.46-3.86C151.14,388.2,149.26,386.67,147.61,384.37Zm-56.53,5.31c-2.17-1.75-3.57-3.71-4.65-3.55-1.5.22-2.76,2.05-4.12,3.19,1.26,1.27,2.35,3.21,3.83,3.57C87.2,393.14,88.77,391.27,91.08,389.68Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M42.64,321.55c11.51,4.44,15.59,13.74,16.47,25,.82,10.45,1,21,2.43,31.34.91,6.55,3.67,12.84,5.61,19.3H3c-.54-4.23-1.21-8.61-1.63-13-.71-7.61-.8-15.31-2-22.83-1.27-7.89-5.9-11.43-13.91-11.5-13.81-.14-27.62,0-41.9,0V397.1h-59.78V242.47h4.94c40.44,0,80.88-.09,121.32.09a129.87,129.87,0,0,1,22.82,1.81c21,3.86,34.77,24,32.05,46C62.91,306.36,58.77,312.2,42.64,321.55Zm-99-39.53v28.35c15.13,0,29.93.3,44.72-.11,9-.26,13.21-5.27,13.17-14.13,0-8.56-4.28-13.75-12.88-14C-26.32,281.72-41.26,282-56.41,282Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M426.19,479c4.91,3.48,5.11,8.35,5.53,13.19.53,6.23,1.18,12.44,1.79,18.75H411.05c-.35-4.54-.76-8.94-1-13.36-.27-4.65-2.39-6.95-7.28-6.66-4.12.24-8.26.05-12.84.05v19.8H368.16V445.47c4.08,0,8.17,0,12.27,0,12.46.09,24.92.21,37.38.29,7.66,0,12.43,4,14.74,11.06,2.66,8.17.74,16.09-4.94,20.93C427.25,478.07,426.91,478.39,426.19,479ZM390,462.21v11.94c5.13,0,10.07,0,15,0,3.81,0,5.46-2.23,5.57-5.61.12-3.6-1.6-6.17-5.5-6.3C400.17,462.08,395.22,462.21,390,462.21Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M730.1,511H707.57c-.32-4.32-.64-8.56-1-12.79-.43-5.82-1.89-7.2-7.75-7.22-4,0-7.93,0-12.34,0v19.83H664.79V445.47c8.74,0,17.35,0,26,0,7.65,0,15.32-.17,22.94.3,9.26.57,13.2,3.76,15.52,11.41,2.54,8.4.26,16.31-6.47,21.67,5.5,3.95,5.09,10,5.62,15.75C728.87,500,729.5,505.4,730.1,511Zm-43.47-36.87h15c3.46,0,5.14-1.86,5.34-5.17.23-3.56-1-6.44-4.91-6.66-5.06-.29-10.15-.07-15.45-.07Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M486.61,511V485.25h-23.7V511H441.3V445.81h21.51v22.11h23.61V445.83h21.49V511Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M358.53,470.1v16.21H325.31v8.49h35.45v16.38H303.54v-65.3h57.23v15.94H325.21v8.28Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M538.91,445.85c0,13.06-.07,25.88,0,38.69.05,7.78,2.85,11,9.46,11.48,8.7.59,12.29-2.73,12.3-11.49,0-12.82,0-25.64,0-38.76h21.49c0,15.39.65,30.55-.2,45.62-.75,13-6.52,19.23-19.38,20.79a110.34,110.34,0,0,1-28.18-.51c-9.93-1.37-16.13-8.52-16.51-18.55-.58-15.61-.15-31.26-.15-47.27Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M633.78,445.78H655.6c0,2,0,4.11,0,6.19-.05,12.33.15,24.67-.22,37-.43,14.3-6.63,21.85-20.71,23.53a102.51,102.51,0,0,1-26.24-.62c-10.95-1.55-17.27-8.78-17.63-19.76-.51-15.3-.13-30.63-.13-46.29h21.27c.07,1.57.22,3.17.22,4.77,0,11.33,0,22.66,0,34,0,8.35,3.09,11.57,10.81,11.54s10.7-3.15,10.77-11.63c.08-11.17,0-22.33,0-33.5Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M230.29,445.72H254l11.79,41.21c1.93-6.52,3.53-11.86,5.08-17.21,2-7,3.92-14.08,6.1-21.05.39-1.24,1.88-3,2.92-3.05,6.94-.27,13.89-.14,21.6-.14-1.3,3.63-2.37,6.68-3.49,9.71-6.39,17.28-12.87,34.53-19.14,51.86-1.13,3.1-2.53,4.48-6,4.21-6.11-.46-13.67,1.75-18-1.14-4-2.71-4.69-10.53-6.77-16.13q-8.24-22.17-16.42-44.35C231.25,448.47,230.85,447.28,230.29,445.72Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M86.39,281.84q14.72-10.15,29.42-20.32c9.51-6.62,19-13.3,29.43-20.63v36.58c-7.36-5.2-14.6-10.39-21.94-15.43-1.28-.88-3-1.11-4.51-1.64l-.81,1.69,29.47,20.82L115.21,305l.07.07a26.18,26.18,0,0,0-3.65-4c-8.55-6.24-17.2-12.35-25.82-18.5C86,282.33,86.2,282.08,86.39,281.84Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M85.2,325.93c-.13,4.6,2.2,3.19,4.33,1.69,8.56-6,17.06-12.1,25.61-18.13a27.45,27.45,0,0,1,3-1.59l.23.26c.82,1.07,1.44,2.41,2.49,3.17q11.07,8.07,22.32,15.9a29,29,0,0,0,5.23,2.34l-31.91,22.51L84.71,329.49c-.21,1.85-.34,3-.49,4.4-.48-.36-.84-.54-.83-.64.46-2.45-1.92-5.66,1.89-7.21Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M114.47,258.29,87.56,277.92V240.63l6.29,4.4c5.29,3.71,10.53,7.5,15.88,11.12a22,22,0,0,0,4.39,1.75A4.4,4.4,0,0,1,114.47,258.29Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M87.45,372.68v-37.3L113.85,354C105.72,359.72,97,365.94,87.45,372.68Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M119.34,306.51l26-18.47v36.81Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M113.53,306.41l-26.12,18.9c0-9.84,0-19,0-28.24,0-4,.94-8.28-3.71-10.62.24-.19.48-.38.72-.59L113,305.73ZM90.35,320.59l.57-.21v-28h-.57Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M118.89,354.71l23.13-17v30.81h1.09c0-9.5,0-19,0-28.5a21.17,21.17,0,0,1,.89-4.22l1.49.31v36.38c-6.17-4.35-12-8.53-17.87-12.54-2.68-1.82-5.6-3.3-8.4-4.94Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M78.44,204.19H155V240c-12.83-.14-25.48-.12-38.11-.47s-25.39,1.64-38.41-.34Zm1.08,1.21v32.35h74.17V205.4Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M115.17,257,97,242.89h39.71l-21,14.7A4.4,4.4,0,0,0,115.17,257Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M137.78,384.81v9.39h-42v-9.39Zm-1.2,3.42a69.58,69.58,0,0,1-9,1.19c-2.73,0-6.5,1.75-7.44-3.05,0-.28-1.15-.5-1.76-.5-7.09,0-14.18,0-21.42,0v7.3c7.6,0,15,.09,22.45-.11.88,0,1.71-1.59,2.56-2.43l-.69-1.5,15.3,1.37Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M85.23,279l1.16,2.86c-.19.24-.38.49-.58.73l-1.39,3.29c-.24.21-.48.4-.72.59a57.77,57.77,0,0,1-.32-6.16c0-.44,1.28-.82,2-1.23Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M115.21,305l-1.68,1.43-.49-.68,2.24-.68Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M118.13,307.9l1.55-1.43.49.57c-.6.38-1.21.75-1.82,1.12Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M85.28,326l.72-.83.27.37-1.07.35Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M85.35,279.06l0-1.06.74.21-.89.77Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M114.12,257.9l1-.94a4.4,4.4,0,0,1,.59.63l-1.29.69C114.36,258.15,114.24,258,114.12,257.9Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className="fill-transparent"
        d="M155.39,394.22l-1.19.81.24-1.51Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className="fill-transparent"
        d="M115.28,305.05l-2.24.68L84.42,285.86l1.39-3.29c8.62,6.15,17.27,12.26,25.82,18.5A26.18,26.18,0,0,1,115.28,305.05Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className="fill-transparent"
        d="M90.35,320.59V292.42h.57v28Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className="fill-transparent"
        d="M79.52,205.4h74.17v32.35H79.52Zm35.85,27.22v-9.9H81.09v9.9Zm35.85-9.89H117.75v9.82h33.47Zm.82-15.49H117.66v13.29H152Zm-36.56-.09H81.05v13.39h34.43Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M115.37,232.62H81.09v-9.9h34.28Zm-1.26-8.51H82.37v7.18h31.74Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M151.22,222.73v9.82H117.75v-9.82Zm-32.28,8.72c10.21,0,20,.12,29.75-.18,1.11,0,2.81-2.4,3-3.85.14-1-1.74-3.37-2.77-3.4-9.92-.26-19.86-.16-30-.16Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M152,207.24v13.29H117.66V207.24Zm-32.85,1v11.36h31.58V208.23Z"
        transform="translate(116.24 -203.89)"
      />
      <path
        className={color}
        d="M115.48,207.15v13.39H81.05V207.15ZM82.39,219.73h31.72V208.36H82.39Z"
        transform="translate(116.24 -203.89)"
      />
    </svg>
  )
}

export default Logo
